module.exports = __webpack_public_path__ + "static/media/auburn-logo.a6073582.svg";